module.exports = __webpack_public_path__ + "static/img/9.074f1130.png";